import http from "../http-common";

class BudgetTypeService {
  getAll() {
    return http.get('/budget-types');
  }

  create(data) {
    return http.post('/budget-types', data);
  }

  update(id, data) {
    return http.put(`/budget-types/${id}`, data);
  }

  delete(id) {
    return http.delete(`/budget-types/${id}`);
  }
}

export default new BudgetTypeService();

